import React from 'react';
import styled from '@emotion/styled';
import SearchIconSVG from '../../../../public/static/search.svg';
import ArrowSVG from '../../../../public/static/arrow.svg';
import XIconSVG from '../../../../public/static/x_icon.svg';

export const StyledWrapper = styled.div`
    position: relative;
    display: flex;

    /* IE11 fix */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        display: block;
    }
`;

export const ControllerButton = styled.button`
    background-color: transparent;
    border: none;
    position: absolute;
    top: 1px;
    cursor: pointer;
    width: 47px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding-right: 5px;
`;

export const RightControllerButton = styled(ControllerButton)`
    right: 0;
`;

export const Icon = styled.span`
    fill: ${(props) => props.theme.shades.blackGrey};
    height: 32px;
    position: absolute;
    top: 9px;
    left: 0px;
    border-right: 1px solid ${(props) => props.theme.colors.black};
    padding: 0 12.5px;
    margin-right: 11px;
`;

interface IArrowIcon {
    isOpen: boolean;
}

// @TODO: Using downshift's props in styled components forces the fonts to be refetched and reloaded
// causing a flash on the page. This happens for every styled component that takes a downshift prop
// as an argument. This behaviour is observed only in the DEV mode.
export const ArrowIcon = styled(({ isOpen, ...rest }: IArrowIcon) => <ArrowSVG {...rest} />)`
    width: 14px;
    height: 14px;
    stroke-width: 2;
    fill: ${(props) => props.theme.shades.darkGrey};
    transform: ${(props) => (props.isOpen ? `rotate(-90deg)` : `rotate(90deg)`)};
`;

export const SearchIcon = styled(SearchIconSVG)`
    margin-top: 3.5px;
    width: 25px;
`;

export const XIcon = styled(XIconSVG)`
    width: 15px;
    height: 15px;
    stroke-width: 2;
    stroke: ${(props) => props.theme.shades.darkGrey};
`;

export const StyledInput = styled.input`
    height: 45px;
    width: 100%;
    padding-left: 13px;
    padding-right: 36px;
    font-size: ${(props) => props.theme.fontSize.regularS};
    border-style: none;
    border-radius: 0;
    background: ${(props) => props.theme.shades.white};
    color: ${(props) => props.theme.shades.blackGrey};
    &:focus {
        opacity: 1;
    }
`;
